/*
Grabberを掴んでHTML要素をドラッグ移動する処理を担う。
イベントへの登録とイベント内で使う変数を保持するのみなので、ただ保持するだけでいい。
*/
export default class GrabbableWindow {
  constructor(elMain, grabberSelector = '.grabber') {
    this.enabled = true;
    this._elMain = elMain;
    this._elGrabber = grabberSelector === null ? elMain : elMain.querySelector(grabberSelector);
    this._isGrabbing = false;

    this._elGrabber.addEventListener('mousedown', e => this._grabberMouseDownHandler(e));
    window.addEventListener('mousemove', e => this._windowMouseMoveHandler(e));
    window.addEventListener('mouseup', e => this._windowMouseMoveHandler(e));

    GrabbableWindow._instances.push(this);
  }
  static _instances = [];
  static get instances() {
    return GrabbableWindow._instances.slice();
  }
  get isGrabbing() {
    return this._isGrabbing;
  }
  _grabberMouseDownHandler(e) {
    if(this.enabled && !this._isGrabbing) {
      if(e.button === 0) {
        const rect = this._elMain.getBoundingClientRect();
        this._grabX = e.x - rect.x;
        this._grabY = e.y - rect.y;
        this._isGrabbing = true;
        document.body.classList.add('forceCursorGrabbing');
        this._elMain.classList.remove('grabberbleWindowTransition');
        this._setLeft(e.x - this._grabX);
        this._setTop(e.y - this._grabY);
      }
    }
  }
  _windowMouseMoveHandler(e) {
    if(this._isGrabbing) {
      if(e.buttons & 1) {
        this._setLeft(e.x - this._grabX);
        this._setTop(e.y - this._grabY);
      } else {
        this._release();
      }
    }
  }
  correctPosition() {
    if(this._elMain.classList.contains('hidden')) return;
    const rect = this._elGrabber.getBoundingClientRect();
    const {innerWidth, innerHeight} = window;
    if(rect.x < 0) {
      this._addTransition();
      this._setLeft(0);
    } else if(innerWidth < rect.right) {
      this._addTransition();
      this._setLeft(innerWidth - rect.width);
    }
    if(rect.y < 0) {
      this._addTransition();
      this._setTop(0);
    } else if(innerHeight < rect.bottom) {
      this._addTransition();
      this._setTop(innerHeight - rect.height);
    }
  }
  _release() {
    this._isGrabbing = false;
    document.body.classList.remove('forceCursorGrabbing');
    this.correctPosition();
  }
  _addTransition() {
    this._elMain.classList.add('grabberbleWindowTransition');
    this._elMain.addEventListener('transitionend', e => {
      switch(e.propertyName) {
      case 'top':
      case 'left':
        this._elMain.classList.remove('grabberbleWindowTransition');
        break;
      }
    }, {once: true});
  }
  _setLeft(x) {
    const left = parseFloat(getComputedStyle(this._elMain).left);
    x += left - this._elMain.getBoundingClientRect().x;
    this._elMain.style.left = GrabbableWindow.pxToPercentX(x);
  }
  _setTop(y) {
    const top = parseFloat(getComputedStyle(this._elMain).top);
    y += top - this._elMain.getBoundingClientRect().y;
    this._elMain.style.top = GrabbableWindow.pxToPercentY(y);
  }
  static pxToPercentX(x) {
    return (x / window.innerWidth * 100).toFixed(2) + '%';
  }
  static pxToPercentY(x) {
    return (x / window.innerHeight * 100).toFixed(2) + '%';
  }
}
